const JWT_PATTERN = /eyJ[\w-]+\.[\w-]+\.[\w-]+/g;
const LONG_OPAQUE_PATTERN = /[A-Za-z0-9_-]{40,}/g;
const FRAME_MAX_LENGTH = 10_000;

/** Removes anything token-shaped from text that is about to be sent to analytics. */
export const redactSensitive = (text: string) =>
  text
    .replace(JWT_PATTERN, '[redacted]')
    .replace(LONG_OPAQUE_PATTERN, '[redacted]');

/** Reads only the `type` of a websocket frame; the rest of the payload is never kept. */
export const frameTypeOf = (data: unknown): string | undefined => {
  if (typeof data !== 'string' || data.length > FRAME_MAX_LENGTH) {
    return undefined;
  }
  try {
    const { type } = JSON.parse(data) as { type?: unknown };
    return typeof type === 'string' ? type.slice(0, 40) : undefined;
  } catch {
    return undefined;
  }
};
